<div class="basin-justify-content-space-between basin-height-100 basin-width-100 basin-position-relative">
  <ng-content select="[slot=overlay]"></ng-content>
  <!-- Map UI Container (Non-Interactive) -->
  <div
    class="map-ui-container basin-flex-row basin basin-position-absolute basin basin-display-flex basin-ml-4 events-none">
    <!-- Map Button Container (Interactive) -->
    <div id="map-button-container" class="basin-display-flex basin-flex-column basin-mt-4 events-none">
      <p-button icon="symbol-help" label="USER GUIDE AND FAQs" class="interactive"
        *ngIf="simulationService.simulationState === simulationState.Ready && (selectedStudyAreaData$ | async) !== null"
        (click)="openJiraLink()" (keydown)="openJiraLink()"></p-button>

      <div class="basin-display-flex basin-flex-column button-container" *ngIf="showControls">
        <p-button styleClass="p-button-raised top-button p-button-neutral" class="basin-pt-2 map-button interactive"
          icon="symbol-add" (click)="controlIn()" (keydown)="controlIn()"></p-button>

        <p-button styleClass="p-button-raised bottom-button p-button-neutral" class="basin-pb-2 map-button interactive"
          icon="symbol-remove" (click)="controlOut()" (keydown)="controlOut()"></p-button>

        <p-button styleClass="p-button-raised p-button-neutral" class="basin-pb-2 map-button interactive"
          icon="symbol-open-with" (click)="togglePanning()" (keydown)="togglePanning()"></p-button>

        <p-button *ngIf="(scenarios$ | async)?.length !== 0" styleClass="p-button-raised p-button-neutral"
          class="map-button interactive" icon="symbol-layers" (click)="controlLayers()"
          (keydown)="controlLayers()"></p-button>
      </div>
    </div>

    <div class="basin-display-flex basin-flex-column basin-ml-8">
      <div class="interactive">
        <ng-content select="[slot=details]"></ng-content>
      </div>
    </div>
  </div>

  <!-- Three.js Canvas - Ensuring Full Interaction -->
  <ng-content select="[slot=canvas]"></ng-content>

  <!-- Non-Blocking Modal Overlays -->
  <div
    class="map-modal top basin-position-absolute basin-display-flex basin-flex-column basin-align-items-end basin-justify-content-start events-none basin-gap-4">
    <ng-content select="[slot=paintInfo]"></ng-content>
  </div>
  <div
    class="map-modal bottom interactive basin-position-absolute basin-display-flex basin-flex-column basin-align-items-end basin-justify-content-end events-none basin-gap-4">
    <ng-content select="[slot=info]"></ng-content>
  </div>
</div>